import axios from 'axios';

import { Modal } from 'react-bootstrap';
import { useState } from 'react';

import { crossIcon } from '../../Assets/svg';
import { getModifiedPlayload } from '../../Util/helpers';

import BASEURL from '../../Config/global';
import { setMixSavedId } from '../../Store/Slices/SaveMixSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const SaveMixModal = ({ isOpen, onClose, onSuccess, tracks }) => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { selectedItem, selectedType, config } = useSelector((state) => state.player);

    const shareList = selectedItem.length > 0 ? selectedItem : tracks;
    // ✅ Local state to manage input value and errors
    const [state, setState] = useState({
        value: "",
        error: false,
        errorMsg: "",
    });

    // ✅ Handle input value change and reset any previous error
    const handleChange = (e) => {
        setState((prev) => ({
            ...prev,
            value: e.target.value,
            error: false,
            errorMsg: "",
        }));
    };

    // ✅ Save mix (playlist) to backend
    const handleSave = async () => {
        const trimmedValue = state.value.trim();

        // 🔸 Validate: check if input is empty
        if (!trimmedValue) {
            setState((prev) => ({
                ...prev,
                error: true,
                errorMsg: t("playlists.enterPlaylistName"),
            }));
            return;
        }

        try {
            // 🔸 Prepare payload for API
            const payload = {
                name: trimmedValue,
                isPlaylist: selectedType === 'playlist',
                sounds_list: getModifiedPlayload(shareList),
                repeat: config?.isRepeat || false,
                shuffle: config?.isShuffle || false,
                playlist_type: config?.playlist_type || null,
            };

            // 🔸 Send POST request to backend
            const response = await axios.post(`${BASEURL}/api/sounds/sounds_mixture`, payload);

            // ✅ If no error in response
            if (!response.data.error) {
                // Update Redux store with new mix data
                dispatch(setMixSavedId(response?.data?.data?.id));
                // Clear input and error state
                setState({ value: "", error: false, errorMsg: "" });
                // Optionally trigger success callback (if needed)
                onSuccess('save-mix-created');
            } else {
                // ❌ Unexpected backend error
                setState({
                    value: "",
                    error: true,
                    errorMsg: t("playlists.unexpectedError"),
                });
            }
        } catch (error) {
            // ❌ Handle network or unexpected error
            setState({
                value: "",
                error: true,
                errorMsg: t("playlists.unexpectedError"),
            });
        }
    };

    return (
        <Modal show={isOpen} centered className="custom-modal" backdrop="static">
            <Modal.Body>
                {/* 🔹 Close button */}
                <div className="text-end">
                    <button
                        className="closeButton notButton ms-auto"
                        onClick={() => onClose('save-mix')}
                    >
                        <img src={crossIcon} alt="Close" />
                    </button>
                </div>

                {/* 🔹 Modal content */}
                <div className="customModalContent mt-4">
                    <h2 className="fs-5 mb-4 pb-2 fw-bold text-center">{t("mixes.mixName")}</h2>

                    {/* 🔹 Input field */}
                    <div>
                        <input
                            type="text"
                            value={state.value}
                            onChange={handleChange}
                            className="searchBar w-100"
                        // placeholder="Enter mix name"
                        />

                        {/* 🔹 Error message */}
                        {state.error && (
                            <small
                                className="text-danger d-inline-block mt-2 text-center"
                                style={{ lineHeight: 1.4 }}
                            >
                                {state.errorMsg}
                            </small>
                        )}
                    </div>

                    {/* 🔹 Save button */}
                    <div className="mt-4 pt-2 d-flex gap-3 justify-content-center">
                        <button
                            style={{ backgroundColor: "#ffffff1f" }}
                            className="px-5 py-2 fs-6 fw-light text-white text-capitalize btn rounded-pill d-flex align-items-center justify-content-center flex-shrink-0"
                            onClick={handleSave}
                        >
                            <span>{t("common.save")}</span>
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default SaveMixModal;
